import React, { useState } from 'react'
import { Layout } from 'antd'
import Header from './Header'


const {Content, Footer} = Layout

function Main (props) {



  const [host] = useState(props.location.host)
  return (
    <Layout style={{height: '100%'}} className="layout">
      <Content style={{padding: '0 50px', margin: 'auto', maxWidth: 1500}}>
        <Header {...{host}}/>
        <div style={{background: '#fff', padding: 24, minHeight: 280}}>{props.children}</div>
      </Content>
      <Footer style={{textAlign: 'center'}}>RMS Africa © 2023</Footer>
    </Layout>
  )
}

export default Main
